import React, { useCallback, useState } from 'react';
import swal from 'sweetalert';
import {  Box, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import DropZoneComponent from '../../component/Dropzone';
import FormButtons from '../../component/FormSubmitCancelButtons';
import { uploadMappingFile } from '../../api/mappingApi';
import excelImage from '../../assets/images/excel.png'
import Loader from '../../component/Loader/Loader';
import { Link } from 'react-router-dom';

const UploadMappingFile = () => {
  const fileType = {
    'application/vnd.ms-excel': ['.xlsx','.xls']
  };
  const [file,setFile]                =  useState([]);
  const [showLoader, setShowLoader]   =  useState(false);
  const handleDrop = useCallback((acceptedFile) => {
    if(acceptedFile.length < 1){
      swal({
        title: 'Error',
        text: 'Please upload vaild file with extension xlsx, xls.',
        icon: "error",
        dangerMode: true,
      });
      return;
    }

    let fileUploadType = acceptedFile[0]?.type;
    let type1 = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    let type2 = 'application/vnd.ms-excel';
    if(!fileUploadType.match(type1) && !fileUploadType.match(type2)){
      swal({
        title: 'Error',
        text: 'Please upload valid file with extension xlsx, xls.',
        icon: "error",
        dangerMode: true,
      });
      return;
    }
    setFile(acceptedFile[0]);
  },[]);
    

  const submitFormFile = async () => {
    
    if(file.length === 0){
      swal({
        title: "Error",
        text: "No file uploaded.",
        icon: "error",
      })
      return;
    }
    const formData = new FormData(); 
    formData.append('uploadedFile', file);
    setShowLoader(true);
    const result = await(uploadMappingFile(formData));
    setShowLoader(false);
    setFile([]);
    if(result){
      swal({
        title: "Success",
        text: result.message,
        icon: "success",
      })
    }
  };

  const emptyFileState = () => {
    setFile([]);
  };

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Upload Mapping File">
        <Typography component={Link} to="/" variant="subtitle2"  color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          Upload Mapping
        </Typography>
      </Breadcrumb>
      <Box component="section">
        <Grid className="contentBox">
          <h2>Please Upload a new Mapping File</h2>
          <DropZoneComponent onDrop={handleDrop} fileType={fileType} />
          {file != '' &&
            <h3>File - <img style={{width:'20px'}} alt="excel" src={excelImage}  /> {file.name}</h3>
          }
          <FormButtons onSubmit={submitFormFile}  onCancel={emptyFileState} />
        </Grid>
      </Box>
    </>
  );
};

export default UploadMappingFile;
